<template>
  <div class="d-flex">
    <button class="btn blue mr-1" @click="previousWeek">
      <i class="fa fa-arrow-left"></i>
    </button>
    <button ref="date-picker" class="no-focus form-control form-control-inline">
      <b>Semaine du {{ startDate }} au {{ endDate }}</b>
    </button>
    <button class="btn blue ml-1" @click="nextWeek">
      <i class="fa fa-arrow-right"></i>
    </button>
  </div>
</template>

<script>
const { DateTime } = require("luxon");

export default {
  props: {
    value: {},
  },
  data() {
    return {
      datePicker: undefined
    };
  },
  computed: {
    startDate() {
      return DateTime.fromSQL(this.value).setLocale("fr").toLocaleString(DateTime.DATE_FULL)
    },
    endDate() {
      return DateTime.fromSQL(this.value).setLocale("fr").plus({days:6}).toLocaleString(DateTime.DATE_FULL)
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      let _this = this;
      let input = this.$refs["date-picker"];

      let datePicker = this.datePicker = $(input).datepicker({
        rtl: App.isRTL(),
        orientation: "right",
        format: "yyyy-mm-dd",
        autoclose: true,
        todayHighlight: true,
        daysOfWeekDisabled: '123456',
        defaultViewDate: this.value
      });

      $(input).datepicker("setDate", this.value);

      this.datePicker.on("changeDate", (e) => {
        let date = DateTime.fromJSDate(e.date).set({weekday:0}).plus({days:7}).toISODate();
        _this.$emit("input", date);
        _this.$emit("change", date);
      });
    },
    nextWeek() {
      let date = DateTime.fromISO(this.value).plus({days:7}).toSQLDate();
      $(this.$refs["date-picker"]).datepicker("setDate", date)
    },
    previousWeek() {
      let date = DateTime.fromISO(this.value).plus({days:-7}).toSQLDate();
      $(this.$refs["date-picker"]).datepicker("setDate", date)
    }
  },
};
</script>

<style lang="scss" scoped>
.input-small2 {
  width: 90px!important;
}
</style>